var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg3Green = function Svg3Green(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-success-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48.328 28.453 2.625-2.86h-4.86v-1.796h7.5v1.25l-2.991 3.187c.875-.01 1.609.29 2.203.899.593.604.89 1.36.89 2.265 0 1.094-.375 1.995-1.125 2.704-.75.703-1.703 1.054-2.859 1.054-1.063 0-1.961-.3-2.695-.898-.73-.604-1.138-1.386-1.227-2.344h1.867c.084.411.308.753.672 1.023.365.266.826.399 1.383.399.604 0 1.099-.185 1.484-.555.386-.37.578-.846.578-1.43 0-.374-.096-.7-.289-.976a1.635 1.635 0 0 0-.757-.617 3.468 3.468 0 0 0-1.102-.235 3.702 3.702 0 0 0-1.297.165v-1.235Z",
    fill: "#fff"
  })));
};

export default Svg3Green;